import { Injectable } from '@angular/core';
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { AuthenticationService } from './auth/auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpClient extends Http {

  constructor(backend: XHRBackend, defaultOptions: RequestOptions, private router: Router, private authService: AuthenticationService) {
    super(backend, defaultOptions);
  }

  // This method is called by Http:get() and Http:post()
  // When called from post() the "url" param will be a "Request", from get() "url" will be a "string"
  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (typeof url === 'string') {
      if (!options) {
        options = { headers: new Headers() };
      }
      url = url;
      this.setHeaders(options);
    } else {
      url.url = url.url;
      this.setHeaders(url);
    }

    return super.request(url, options).catch(this.catchErrors());
  }

  // Method to catch permissions denied responses
  private catchErrors() {
    return (res: Response) => {
      if (res.status === 401 || res.status === 403 || res.status === 500 || res.status === 422) {
        const response = <any>res;
        let redirect = true;

        if (JSON.parse(response._body).msg !== 'invalid signature' &&
            JSON.parse(response._body).msg !== 'Signature verification failed' &&
            JSON.parse(response._body).msg !== 'Token has expired') {
          redirect = false;
        }
        if (redirect) {
          this.router.navigate(['login']);
        }
      }
      return Observable.throw(res);
    };
  }

  // Setting the auth token in the headers for each request
  private setHeaders(objectToSetHeadersTo: Request | RequestOptionsArgs) {
    const user = this.authService.getUser();
    if (user && this.router.isActive('historic', false)) {
      objectToSetHeadersTo.headers.set('Authorization', user.token);
     }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/http.client.ts